__turbopack_context__.v({
  "newsContainer": "Eo2OgW_newsContainer",
  "newsHeading": "Eo2OgW_newsHeading",
});
